import { render } from "./progress_bar.vue?vue&type=template&id=88d0f982&scoped=true"
import script from "./progress_bar.vue?vue&type=script&lang=js"
export * from "./progress_bar.vue?vue&type=script&lang=js"

import "./progress_bar.vue?vue&type=style&index=0&id=88d0f982&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d0f982"]])

export default __exports__